import { useCallback, useEffect, useState } from 'react'

// How long a label stays up once it has something new to say.
export const FOLD_AFTER_MS = 10_000

/**
 * A label that shows for ten seconds, then folds away to its icon or dots.
 * It unfolds again whenever `content` changes, and the countdown waits while
 * `paused`. Returns [folded, show]: `show()` unfolds it and starts the ten
 * seconds over.
 *
 * Everything that folds starts counting on the same render (the sections
 * arriving), so the map's chrome folds away in one go.
 */
export function useFold(content, paused = false) {
  const [folded, setFolded] = useState(false)
  const [round, setRound] = useState(0)

  useEffect(() => setFolded(false), [content])
  useEffect(() => {
    if (paused || folded) return
    const id = setTimeout(() => setFolded(true), FOLD_AFTER_MS)
    return () => clearTimeout(id)
  }, [paused, folded, content, round])

  const show = useCallback(() => {
    setFolded(false)
    setRound((r) => r + 1)
  }, [])

  return [folded, show]
}
